import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahLateSubmissionReasons } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { SahLateSubmissionReason } from '~lookups/models';

export const typePrefix = 'sah-late-submission-reasons';

export const sahLateSubmissionReasonsApi = createApi({
  reducerPath: 'sahLateSubmissionReasonsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahLateSubmissionReasons }),
  tagTypes: ['sah-late-submission-reasons'],
  endpoints: (builder) => ({
    getSahLateSubmissionReasons: builder.query<SahLateSubmissionReason[], Request | void>({
      query: (params) => ({ url: '', method: 'GET', params: { ...params } }),
      providesTags: [{ type: 'sah-late-submission-reasons', id: 'LIST' }],
      transformResponse: (payload) => unwrap<SahLateSubmissionReason[]>(payload),
    }),
  }),
});

export const { useGetSahLateSubmissionReasonsQuery } = sahLateSubmissionReasonsApi;
